var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',_vm._b({ref:`tabsRef${_vm.num}`,style:({
  '--color': _vm.color, '--active-color': _vm.activeColor, '--hover-color': _vm.hoverColor,'--activeBar':_vm.activeBar
}),model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},'el-tabs',_vm.$attrs,false),[_vm._l((_vm.data),function(item){return [_c('el-tab-pane',{attrs:{"label":item.文本,"name":item.文本}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }